import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Circle, Flag } from 'lucide-react';

const Slide13Roadmap = () => {
    const milestones = [
        { status: 'done', title: 'POC & AI Prototype', date: 'Q4 2025' },
        { status: 'current', title: 'Seed Raise', date: 'Q1 2026' },
        { status: 'future', title: 'AI Infra & Compliance', date: 'Q2 2026' },
        { status: 'future', title: 'MVP Launch', date: 'Q3 2026' },
        { status: 'future', title: '10k Beta Users', date: 'Q4 2026' },
    ];

    return (
        <div className="w-full h-full bg-background p-8 lg:p-16 flex flex-col items-center justify-center relative">
            {/* Background Grid Texture */}
            <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
                style={{ backgroundImage: 'linear-gradient(white 1px, transparent 1px), linear-gradient(90deg, white 1px, transparent 1px)', backgroundSize: '40px 40px' }}
            />
            <motion.div className="text-center mb-16">
                <h2 className="text-4xl lg:text-6xl font-bold mb-4">Path to <span className="text-primary">Scale</span></h2>
                <p className="text-xl text-muted-foreground">Phases gated by engagement & outcome KPIs.</p>
            </motion.div>

            <div className="relative w-full max-w-6xl">
                {/* Horizontal Line */}
                <div className="absolute top-[27px] left-0 w-full h-1 bg-border z-0">
                    <motion.div
                        initial={{ width: 0 }}
                        animate={{ width: '35%' }}
                        transition={{ duration: 1, delay: 0.5 }}
                        className="h-full bg-primary"
                    />
                </div>

                <div className="flex justify-between items-start relative z-10 w-full">
                    {milestones.map((item, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.2 }}
                            className="flex flex-col items-center group w-48 text-center"
                        >
                            <div className={`
                            w-14 h-14 rounded-full border-4 flex items-center justify-center bg-background mb-4 transition-all duration-300
                            ${item.status === 'done' ? 'border-primary text-primary' : ''}
                            ${item.status === 'current' ? 'border-primary shadow-[0_0_30px_rgba(0,255,0,0.6)] scale-125' : ''}
                            ${item.status === 'future' ? 'border-muted text-muted-foreground' : ''}
                        `}>
                                {item.status === 'done' && <CheckCircle2 className="w-6 h-6" />}
                                {item.status === 'current' && <Flag className="w-6 h-6 text-primary fill-current" />}
                                {item.status === 'future' && <Circle className="w-4 h-4" />}
                            </div>

                            <h3 className={`text-lg font-bold mb-1 ${item.status === 'current' ? 'text-primary' : 'text-white'}`}>
                                {item.title}
                            </h3>
                            <span className="text-sm text-muted-foreground font-mono">{item.date}</span>
                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Slide13Roadmap;